/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Arrow16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M7.646 7.646L4.354 4.354a.5.5 0 010-.708l1.292-1.292a.5.5 0 01.708 0l5.292 5.292a.5.5 0 010 .708l-5.292 5.292a.5.5 0 01-.708 0l-1.292-1.292a.5.5 0 010-.708l3.292-3.292a.5.5 0 000-.708z"
        />
    </AccessibleSVG>
);

export default Arrow16;
